import Toastr from "../../../../../../itrust_common/components/Toastr"

const DEFAULT_STATE = {
  saving: false,
  lens_options_configurations: [],
  lenses_configurations: [],
  os: {
    style_list: [],
    basic_lists: [],
    diameter_lists: [],
    sphere_lists: [],
    cylinder_lists: [],
    axis_lists: [],
    bifocal_lists: [],
    lenses_configurations: [],
    lens_options_configurations: [],
    add_power_lists: [],
    add_power_range_lists: [],
    contact_lens_id: [],
  },
  od: {
    style_list: [],
    basic_lists: [],
    diameter_lists: [],
    sphere_lists: [],
    cylinder_lists: [],
    axis_lists: [],
    bifocal_lists: [],
    lenses_configurations: [],
    lens_options_configurations: [],
    add_power_lists: [],
    add_power_range_lists: [],
    contact_lens_id: [],
  }
}

let changes = null

export const specteraReducer = (state = DEFAULT_STATE, action) => {
  const response = action.payload && (action.payload.data || action.payload.response)

  switch (action.type) {

    // case 'SPECTERA_STYLE_LIST_LOAD_PENDING':
    // case 'SPECTERA_BASIC_LISTS_LOAD_PENDING':
    // case 'SPECTERA_DIAMETER_LISTS_LOAD_PENDING':
    // case 'SPECTERA_SPHERE_LISTS_LOAD_PENDING':
    // case 'SPECTERA_CYLINDER_LISTS_LOAD_PENDING':
    // case 'SPECTERA_AXIS_LISTS_LOAD_PENDING':
    // case 'SPECTERA_BIFOCAL_LISTS_LOAD_PENDING':
    // case 'SPECTERA_LENSES_CONFIGURATIONS_LOAD_PENDING':
    // case 'SPECTERA_LENS_OPTIONS_CONFIGURATIONS_LOAD_PENDING':
    // case 'SPECTERA_ADD_POWER_LISTS_LOAD_PENDING':
    // case 'SPECTERA_ADD_POWER_RANGE_LISTS_LOAD_PENDING':
    // case 'SPECTERA_CONTACT_LENS_ID_LOAD_PENDING':
    //   return { ...state, saving: true };

    case 'SPECTERA_STYLE_LIST_LOAD_REJECTED':
    case 'SPECTERA_BASIC_LISTS_LOAD_REJECTED':
    case 'SPECTERA_DIAMETER_LISTS_LOAD_REJECTED':
    case 'SPECTERA_SPHERE_LISTS_LOAD_REJECTED':
    case 'SPECTERA_CYLINDER_LISTS_LOAD_REJECTED':
    case 'SPECTERA_AXIS_LISTS_LOAD_REJECTED':
    case 'SPECTERA_BIFOCAL_LISTS_LOAD_REJECTED':
    case 'SPECTERA_LENSES_CONFIGURATIONS_LOAD_REJECTED':
    case 'SPECTERA_LENS_OPTIONS_CONFIGURATIONS_LOAD_REJECTED':
    case 'SPECTERA_ADD_POWER_LISTS_LOAD_REJECTED':
    case 'SPECTERA_ADD_POWER_RANGE_LISTS_LOAD_REJECTED':
    case 'SPECTERA_CONTACT_LENS_ID_LOAD_REJECTED':
      Toastr.handleShow(false, response?.data?.error, response?.data?.status)
      changes = { saving: false }
      return { ...state, ...changes };

    case 'SPECTERA_STYLE_LIST_LOAD_FULFILLED':
    case 'SPECTERA_BASIC_LISTS_LOAD_FULFILLED':
    case 'SPECTERA_DIAMETER_LISTS_LOAD_FULFILLED':
    case 'SPECTERA_SPHERE_LISTS_LOAD_FULFILLED':
    case 'SPECTERA_CYLINDER_LISTS_LOAD_FULFILLED':
    case 'SPECTERA_AXIS_LISTS_LOAD_FULFILLED':
    case 'SPECTERA_BIFOCAL_LISTS_LOAD_FULFILLED':
    case 'SPECTERA_ADD_POWER_LISTS_LOAD_FULFILLED':
    case 'SPECTERA_ADD_POWER_RANGE_LISTS_LOAD_FULFILLED':
    case 'SPECTERA_CONTACT_LENS_ID_LOAD_FULFILLED':
      changes = { [response?.metadata?.lens_type || 'os']: {...state[response?.metadata?.lens_type || 'os'], ...response }, saving: false }
      return { ...state, ...changes };

    case 'SPECTERA_LENSES_CONFIGURATIONS_LOAD_FULFILLED': {
      const lensConfigurations = response?.lenses_configurations || (Array.isArray(response) ? response : [])
      const lensType = response?.metadata?.lens_type || 'os'
      changes = {
        lenses_configurations: lensConfigurations,
        [lensType]: {
          ...state[lensType],
          lenses_configurations: lensConfigurations,
          ...(response && !Array.isArray(response) && typeof response === 'object' ? response : {}),
        },
        saving: false,
      }
      return { ...state, ...changes };
    }

    case 'SPECTERA_LENS_OPTIONS_CONFIGURATIONS_LOAD_FULFILLED': {
      const lensOptions = response?.lens_options_configurations || (Array.isArray(response) ? response : [])
      const lensType = response?.metadata?.lens_type || 'os'
      changes = {
        lens_options_configurations: lensOptions,
        [lensType]: {
          ...state[lensType],
          lens_options_configurations: lensOptions,
          ...(response && typeof response === 'object' ? response : {}),
        },
        saving: false,
      }
      return { ...state, ...changes };
    }

    default:
      return state
  }
}